import { fromJS } from "immutable";

export const STATE_CONFIG = "config";
export const STATE_CONFIG_DATA = "data";
export const STATE_CONFIG_ERRORS = "errors";
export const STATE_CONFIG_FETCHING = "fetching";
export const STATE_CONFIG_STYLES = "styles";
export const STATE_CONFIG_PERSISTENT_MENU = "persistent_menu";
export const STATE_CONFIG_IMAGE_URL = "image_url";
export const STATE_CONFIG_GREETING_TEXT = "greeting_text";

export const STATE_CONFIG_DEFAULT = fromJS({
  [STATE_CONFIG_DATA]: {},
  [STATE_CONFIG_ERRORS]: [],
  [STATE_CONFIG_FETCHING]: {},
});
